import type { CommerceConfig } from "../types/landing";
/**
 * CONFIGURACIÓN COMERCIAL
 * Completá estos valores con datos reales antes de publicar.
 * Mientras estén vacíos, la landing muestra "Precio a confirmar"
 * y los botones de compra quedan deshabilitados.
 */
export const commerce: CommerceConfig = {
  plans: {
    base: {
      price: "$29.999",
      originalPrice: "$59.999",
      checkoutUrl: "https://checkout.practicandsimple.shop/cart/67791201403249:1",
    },
    pro: {
      price: "$34.999",
      originalPrice: "$69.999",
      checkoutUrl: "https://checkout.practicandsimple.shop/cart/67791203271025:1",
    },
    completo: {
      price: "$39.999",
      originalPrice: "$79.999",
      checkoutUrl: "https://checkout.practicandsimple.shop/cart/67791206842737:1",
    },
  },
  popularity: {
    mostPurchased: { enabled: true, planId: "completo" },
    mostRecommendedByBuyers: { enabled: false, planId: "completo" },
  },
  delivery: {
    channel: "",
    timeframe: "",
  },
  support: "",
  refundPolicy: "",
  contactEmail: "",
  legalLinks: [
    { label: "Términos y condiciones", url: "" },
    { label: "Política de privacidad", url: "" },
  ],
};
export const metaPixelId = "2207420673161327";
export const siteTitle = "Megapack para Aprender Japonés";
export const brandAssets = {
  logo: "https://cdn.magicpatterns.com/uploads/pFBsjXK5DGe538tg77Wg6s/Logo_Referencia_Recursos_Practic_and_Simple.png",
  mockup: "https://cdn.magicpatterns.com/uploads/soKaZ4d4cfJXwKcX61qSF6/MOCKUP.png",
  mockupSize: 1254,
};
